import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { shipmentItemInventoryStatus } from '../../../../fulfillment-plan/sections/shipment-items/helpers/get-item-inventory-status';
import messages from '../../messages';
import style from './item-stock.module.less';

const icons = {
  [shipmentItemInventoryStatus.hasLowStock]: faExclamationCircle,
  [shipmentItemInventoryStatus.isAllocated]: faLock,
  [shipmentItemInventoryStatus.isAvailable]: faCheck,
  [shipmentItemInventoryStatus.isUnknown]: faCircleQuestion,
};

/**
 * @param {object} props
 * @param {string} [props.status] - Inventory status
 * @returns {JSX.Element}
 */
export const InventoryStatusIcon = ({ status = shipmentItemInventoryStatus.isAvailable }) => {
  const icon = icons[status];

  if (status === shipmentItemInventoryStatus.isAllocated) {
    return (
      <Tooltip>
        <TooltipContent>
          <FormattedMessage {...messages.allocatedStockTooltipContent} />
        </TooltipContent>
        <div className={style['icon-wrapper']}>
          <FontAwesomeIcon className={classnames(style.icon, style['is-allocated-icon'])} icon={icon} />
        </div>
      </Tooltip>
    );
  }

  return (
    <div className={style['icon-wrapper']}>
      <FontAwesomeIcon className={style.icon} icon={icon} />
    </div>
  );
};
